var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-s"},[_c('div',{staticStyle:{"width":"100%","margin-top":"-20px"},style:(_vm.myChartStyle),attrs:{"id":"main1"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }